import React, {
  ReactNode,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react';

import useApi from '@/hooks/useApi';

import { TRecommendation as TRecommendation1 } from '@/services/requests/Recommendation/types/template1';
import { TRecommendation as TRecommendation2 } from '@/services/requests/Recommendation/types/template2';
import { TRecommendation as TRecommendation3 } from '@/services/requests/Recommendation/types/template3';
import { TRecommendation as TRecommendation4 } from '@/services/requests/Recommendation/types/template4';
import { TRecommendation as TRecommendation5 } from '@/services/requests/Recommendation/types/template5';
import { TRecommendation as TRecommendation6 } from '@/services/requests/Recommendation/types/template6';
import { TRecommendation as TRecommendation7 } from '@/services/requests/Recommendation/types/template7';
import { dispatchInteraction } from '@/services/requests/Interactions/helpers';
import { TDisplayedService } from '@/services/requests/Interactions/types';
import { sendTagEventFunction } from '@/services/requests/AmplitudeTag';

import { isViewed } from '@/helpers/HtmlHelper/isViewed';

export type TProps = {
  children: ReactNode;
  data:
    | TRecommendation1[]
    | TRecommendation2[]
    | TRecommendation3[]
    | TRecommendation4[]
    | TRecommendation5[]
    | TRecommendation6[]
    | TRecommendation7[];
  [x: string]: ReactNode;
};

export const Section = ({ data, children, ...rest }: TProps) => {
  const templateRef = useRef<HTMLElement>(null);

  const { Api } = useApi();

  const [viewed, setViewed] = useState(false);

  const handlerShowcaseDisplayed = useCallback(() => {
    if (!viewed && templateRef.current && isViewed(templateRef.current)) {
      setViewed(true);
    }
  }, [viewed]);

  useLayoutEffect(() => {
    window.addEventListener('scroll', handlerShowcaseDisplayed, {
      passive: true,
    });
    return () => window.removeEventListener('scroll', handlerShowcaseDisplayed);
  }, [handlerShowcaseDisplayed]);

  useEffect(() => {
    handlerShowcaseDisplayed();
  }, [handlerShowcaseDisplayed]);

  useEffect(() => {
    if (viewed) {
      if (data[0].tag_events) {
        const selectEvent = data[0].tag_events.find(
          event => event.event === 'view_item_list',
        );
        if (selectEvent) {
          sendTagEventFunction(selectEvent.data, selectEvent.event);
        }
      }
      dispatchInteraction<TDisplayedService>(Api, 'displayed', {
        recommendationId: data[0].id,
      });
    }
  }, [Api, data, viewed]);

  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <section ref={templateRef} {...rest}>
      {children}
    </section>
  );
};
